<template>
    <div class="registration-activation">
        <h1>{{ metaData.header }}</h1>
        <v-row class="justify-center mx-0">
            <v-col cols="12" sm="6" md="4">
                <v-alert type="success" v-if="successMessage">
                    {{ successMessage }}
                </v-alert>
                <v-alert type="error" v-if="errorMessage">
                    {{ errorMessage }}
                </v-alert>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import AuthService from '../../../app-front/services/api/AuthService';

    export default {
        name: "ActivationAccount",
        props: ['hash'],
        data() {
            return {
                errorMessage: '',
                metaUrl: '/account-activate',
                successMessage: ''
            }
        },
        methods: {
            sendData() {
                AuthService.accountActivate(this.hash)
                    .then(res => {
                        if(res.data.success) {
                            this.successActivation(res.data.success);
                        }

                        if(res.data.error) {
                            this.errorMessage = res.data.error;
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.errorMessages = this.$t('activateError');
                    });
            },

            successActivation(data) {
                this.successMessage = data.message;

                setTimeout(() => {
                    this.initLogin(data.token);
                    this.$router.push('/');
                }, 2000);
            }
        },
        mounted() {
            this.sendData();
        }
    }
</script>

<style scoped>

</style>
